import { render, staticRenderFns } from "./MyContactReports.vue?vue&type=template&id=fbaace60&scoped=true&"
import script from "./MyContactReports.vue?vue&type=script&lang=js&"
export * from "./MyContactReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbaace60",
  null
  
)

export default component.exports